document.addEventListener('click', function(e){

  const a = e.target.closest('a[href^="#"]');

  if(!a) return;

  const id = a.getAttribute('href');

  if(id === '#') {
    e.preventDefault();
    return;
  }

  const target = document.querySelector(id);

  if(!target){
    e.preventDefault();
  }

}, true);

$('.logo-list__slider').flickity({
  autoPlay: 500 // 5 seconds
});